import { ensureFileType } from "@/helpers/fileUploads";
import type { MultipartUploadTarget, UploadTarget } from "@/types/uploadTarget";
import { CHUNK_SIZE, INITIATE_CONCURRENCY, initiateUploadTargets, newUploadId } from "@uploads";
import { createAdminUploadTargetInitiator } from "./adminUploadTargetInitiator";
import { prepareDurableUploadTargets, type DurableUploadBatchOptions } from "./adminDurableUploadBatch";

export { INITIATE_CONCURRENCY };

export async function getAllUploadTargets(
	images: File[],
	documents: File[],
	videos: File[],
	conversationId: string,
	projectChecklistItemId?: string,
	durableBatch?: DurableUploadBatchOptions
): Promise<Array<UploadTarget | undefined>> {
	if (durableBatch) {
		return prepareDurableUploadTargets([...images, ...documents, ...videos].map(ensureFileType), conversationId, projectChecklistItemId, durableBatch);
	}
	return initiateUploadTargets<File, MultipartUploadTarget>({
		images: images.map(ensureFileType),
		documents: documents.map(ensureFileType),
		videos: videos.map(ensureFileType),
		initiator: createAdminUploadTargetInitiator(conversationId, projectChecklistItemId),
		chunkSize: CHUNK_SIZE,
		createStableId: newUploadId
	});
}
